// extracted by mini-css-extract-plugin
export default {"mainLayout":"MainLayout_mainLayout__lVqSx","content":"MainLayout_content__2MG+d"};